import { render, staticRenderFns } from "./ContactsView.vue?vue&type=template&id=2860335d&scoped=true"
import script from "./ContactsView.vue?vue&type=script&lang=js"
export * from "./ContactsView.vue?vue&type=script&lang=js"
import style0 from "./ContactsView.vue?vue&type=style&index=0&id=2860335d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2860335d",
  null
  
)

export default component.exports